<div class="mr-2 flex h-full w-[350px] flex-col overflow-hidden">
  <h2 class="mb-4">{{ "chat.label.threads" | translate }}</h2>

  <!-- Search field -->
  <mat-form-field class="w-full">
    <mat-icon
      matIconPrefix
    >search</mat-icon>
    <mat-label>{{ "chat.label.searchPlaceholder" | translate }}</mat-label>
    <input
      matInput
      [formControl]="searchFc"
    />
  </mat-form-field>

  <!-- Show tabs only when not searching -->
  @if (!isSearching()) {
    <mat-tab-group
      [selectedIndex]="tabIndex()"
      class="-mt-1 flex-1 [&_.mat-mdc-tab-body-content]:h-full [&_.mat-mdc-tab-body-content]:overflow-hidden [&_.mat-mdc-tab-body-wrapper]:h-[calc(100%-48px)] [&_.mat-mdc-tab-body]:h-full [&_.mat-mdc-tab-group]:h-full"
      (selectedTabChange)="onTabChange($event.index)"
      animationDuration="200ms"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ "chat.label.allChats" | translate }}</span>
        </ng-template>

        <div class="flex h-full flex-col">
          @if (isLoading()) {
            <div class="flex h-full w-full items-center justify-center">
              <shared-loader></shared-loader>
            </div>
          } @else {
            <chat-threads-list
              [selectedThread]="selectedThread()"
              [threads]="filteredThreads()"
              [unreads]="unreads()"
              [systemUsers]="systemUsers()"
              [ownUserId]="ownUserId()"
              (openThread)="onOpenThread($event)"
              (pinThread)="onPinThread($event)"
              (unpinThread)="onUnpinThread($event)"
            />
          }
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ "chat.label.inQueue" | translate }}</span>
          @if (inQueueCount() > 0) {
            <div class="mx-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-error-500 text-xs text-neutral-0">
              {{ inQueueCount() > 9 ? "9+" : inQueueCount() }}
            </div>
          }
        </ng-template>

        <div class="flex h-full flex-col">
          @if (isLoading()) {
            <div class="flex h-full w-full items-center justify-center">
              <shared-loader></shared-loader>
            </div>
          } @else {
            <chat-threads-list
              [selectedThread]="selectedThread()"
              [threads]="filteredThreads()"
              [unreads]="unreads()"
              [systemUsers]="systemUsers()"
              [ownUserId]="ownUserId()"
              (openThread)="onOpenThread($event)"
              (pinThread)="onPinThread($event)"
              (unpinThread)="onUnpinThread($event)"
            />
          }
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ "chat.label.myChats" | translate }}</span>
          @if (myChatsCount() > 0) {
            <div class="mx-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-error-500 text-xs text-neutral-0">
              {{ myChatsCount() > 9 ? "9+" : myChatsCount() }}
            </div>
          }
        </ng-template>

        <div class="flex h-full flex-col">
          @if (isLoading()) {
            <div class="flex h-full w-full items-center justify-center">
              <shared-loader></shared-loader>
            </div>
          } @else {
            <chat-threads-list
              [selectedThread]="selectedThread()"
              [threads]="filteredThreads()"
              [unreads]="unreads()"
              [systemUsers]="systemUsers()"
              [ownUserId]="ownUserId()"
              (openThread)="onOpenThread($event)"
              (pinThread)="onPinThread($event)"
              (unpinThread)="onUnpinThread($event)"
            />
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <!-- Search results view -->
    <div class="h-full flex-1">
      @if (isLoading()) {
        <div class="flex h-full w-full items-center justify-center">
          <shared-loader></shared-loader>
        </div>
      } @else {
        <chat-threads-list
          [selectedThread]="selectedThread()"
          [threads]="filteredThreads()"
          [unreads]="unreads()"
          [systemUsers]="systemUsers()"
          [ownUserId]="ownUserId()"
          (openThread)="onOpenThread($event)"
          (pinThread)="onPinThread($event)"
          (unpinThread)="onUnpinThread($event)"
        />
      }
    </div>
  }
</div>
